
(function() {
  var result = { translations: { "pt-br": { "SharedI18nStrings": { "languageNames": { "af": "Afric\xE2ner", "sq": "Alban\xEAs", "sq-al": "Alban\xEAs - Alb\xE2nia", "ar": "\xC1rabe", "ar-dz": "\xC1rabe - Arg\xE9lia", "ar-bh": "\xC1rabe - Barein", "ar-eg": "\xC1rabe - Egito", "ar-iq": "\xC1rabe - Iraque", "ar-jo": "\xC1rabe - Jord\xE2nia", "ar-kw": "\xC1rabe - Kuwait", "ar-lb": "\xC1rabe - L\xEDbano", "ar-ly": "\xC1rabe - L\xEDbia", "ar-ma": "\xC1rabe - Marrocos", "ar-om": "\xC1rabe - Om\xE3", "ar-qa": "\xC1rabe - Catar", "ar-sa": "\xC1rabe - Ar\xE1bia Saudita", "ar-sd": "\xC1rabe - Sud\xE3o", "ar-sy": "\xC1rabe - S\xEDria", "ar-tn": "\xC1rabe - Tun\xEDsia", "ar-ae": "\xC1rabe - Emirados \xC1rabes Unidos", "ar-ye": "\xC1rabe - I\xEAmen", "as": "Assam\xEAs", "az": "Azerbaijano", "hy": "Arm\xEAnio", "eu": "Basco", "be": "Bielorrusso", "be-by": "Bielorrusso - Bielorr\xFAssia", "bn": "Bengali", "bg": "B\xFAlgaro", "bg-bg": "B\xFAlgaro - Bulg\xE1ria", "bs": "B\xF3snio", "ca": "Catal\xE3o", "ca-es": "Catal\xE3o - Catal\xE3o", "zh": "Chin\xEAs", "zh-cn": "Chin\xEAs - Simplificado", "zh-hk": "Chin\xEAs - Hong Kong", "zh-mo": "Chin\xEAs - Macau", "zh-sg": "Chin\xEAs - Singapura", "zh-tw": "Chin\xEAs - Tradicional", "zh-chs": "Chin\xEAs (simplificado)", "zh-cht": "Chin\xEAs (tradicional)", "zh-hans": "Chin\xEAs (Han simplificado)", "zh-hant": "Chin\xEAs (Han tradicional)", "hr": "Croata", "hr-hr": "Croata - Cro\xE1cia", "cs": "Checo", "cs-cz": "Tcheco - Rep\xFAblica Tcheca", "da": "Dinamarqu\xEAs", "da-dk": "Dinamarqu\xEAs - Dinamarca", "nl": "Holand\xEAs", "nl-be": "Holand\xEAs - B\xE9lgica", "nl-ch": "Holand\xEAs - Su\xED\xE7a", "nl-lu": "Holand\xEAs - Luxemburgo", "nl-nl": "Holand\xEAs - Holanda", "en": "Ingl\xEAs", "en-ae": "Ingl\xEAs - Emirados \xC1rabes Unidos", "en-au": "Ingl\xEAs - Austr\xE1lia", "en-be": "Ingl\xEAs - B\xE9lgica", "en-ca": "Ingl\xEAs - Canad\xE1", "en-ch": "Ingl\xEAs - Su\xED\xE7a", "en-cn": "Ingl\xEAs - China", "en-de": "Ingl\xEAs - Alemanha", "en-ee": "Ingl\xEAs - Est\xF4nia", "en-es": "Ingl\xEAs - Espanha", "en-fr": "Ingl\xEAs - Fran\xE7a", "en-hk": "Ingl\xEAs - Hong Kong", "en-in": "Ingl\xEAs - \xCDndia", "en-ie": "Ingl\xEAs - Irlanda", "en-ke": "Ingl\xEAs - Qu\xEAnia", "en-lu": "Ingl\xEAs - Luxemburgo", "en-my": "Ingl\xEAs - Mal\xE1sia", "en-mt": "Ingl\xEAs - Malta", "en-mx": "Ingl\xEAs - M\xE9xico", "en-nl": "Ingl\xEAs - Holanda", "en-nz": "Ingl\xEAs - Nova Zel\xE2ndia", "en-ph": "Ingl\xEAs - Filipinas", "en-pk": "Ingl\xEAs - Paquist\xE3o", "en-se": "Ingl\xEAs - Su\xE9cia", "en-sg": "Ingl\xEAs - Singapura", "en-tn": "Ingl\xEAs - Tun\xEDsia", "en-za": "Ingl\xEAs - \xC1frica do Sul", "en-gb": "Ingl\xEAs - Reino Unido", "en-us": "Ingl\xEAs - Estados Unidos", "en-zw": "Ingl\xEAs - Zimb\xE1bue", "et": "Estoniano", "et-ee": "Estoniano - Est\xF4nia", "fo": "Faro\xEAs", "fa": "Farsi", "fi": "Finland\xEAs", "fi-fi": "Finland\xEAs - Finl\xE2ndia", "fil": "Filipino", "fr": "Franc\xEAs", "fr-be": "Franc\xEAs - B\xE9lgica", "fr-ca": "Franc\xEAs - Canad\xE1", "fr-fr": "Franc\xEAs - Fran\xE7a", "fr-lu": "Franc\xEAs - Luxemburgo", "fr-mc": "Franc\xEAs - M\xF4naco", "fr-ch": "Franc\xEAs - Su\xED\xE7a", "fr-tn": "Franc\xEAs - Tun\xEDsia", "gl": "Galego", "ka": "Georgiano", "de": "Alem\xE3o", "de-at": "Alem\xE3o - \xC1ustria", "de-de": "Alem\xE3o - Alemanha", "de-gr": "Alem\xE3o - Gr\xE9cia", "de-li": "Alem\xE3o - Liechtenstein", "de-lu": "Alem\xE3o - Luxemburgo", "de-ch": "Alem\xE3o - Su\xED\xE7a", "el": "Grego", "el-cy": "Grego - Chipre", "el-gr": "Grego - Gr\xE9cia", "gu": "Gujarati", "haw": "Havaiano", "ha": "Hau\xE7\xE1", "he": "Hebraico", "he-il": "Hebraico - Israel", "iw-il": "Hebraico - Israel", "hi": "Hindu", "hi-in": "Hindu - \xCDndia", "hu": "H\xFAngaro", "hu-hu": "H\xFAngaro - Hungria", "is": "Island\xEAs", "is-is": "Island\xEAs - Isl\xE2ndia", "id": "Indon\xE9sio", "in-id": "Indon\xE9sio - Indon\xE9sia", "ga": "Irland\xEAs", "ga-ie": "Irland\xEAs - Irlanda", "it": "Italiano", "it-it": "Italiano - It\xE1lia", "it-ch": "Italiano - Su\xED\xE7a", "ja": "Japon\xEAs", "ja-jp": "Japon\xEAs - Jap\xE3o", "kn": "Kannada", "kk": "Cazaque", "kok": "Concani", "ko": "Coreano", "ko-kr": "Coreano - Cor\xE9ia do Sul", "ku": "Curdo", "ky": "Quirguiz", "ky-kg": "Quirguiz", "lo": "Laos", "lv": "Let\xE3o", "lv-lv": "Let\xE3o - Let\xF4nia", "lt": "Lituano", "lt-lt": "Lituano - Litu\xE2nia", "mk": "Maced\xF4nio", "mk-mk": "Maced\xF4nio - Maced\xF4nia", "ml": "Malaiala", "ms": "Malaio", "ms-bn": "Malaio - Brunei", "ms-my": "Malaio - Mal\xE1sia", "mt": "Malt\xEAs", "mt-mt": "Malt\xEAs - Malta", "mr": "Marata", "mn": "Mongol", "my": "Birman\xEAs", "my-mm": "Birman\xEAs - Myanmar (Birm\xE2nia)", "ne": "Nepal\xEAs", "no": "Noruegu\xEAs", "nb": "Noruegu\xEAs Bokmal", "nb-no": "Noruegu\xEAs Bokmal - Noruega", "no-no": "Noruegu\xEAs - Noruega", "pl": "Polon\xEAs", "pl-pl": "Polon\xEAs - Pol\xF4nia", "pt": "Portugu\xEAs", "pt-br": "Portugu\xEAs - Brasil", "pt-pt": "Portugu\xEAs - Portugal", "pa": "Panjabi", "pa-in": "Punjabi \u2013 \xCDndia", "pa-pk": "Punjabi \u2013 Paquist\xE3o", "ro": "Romeno", "ro-ro": "Romeno - Rom\xEAnia", "ru": "Russo", "ru-ru": "Russo - R\xFAssia", "rw-rw": "Kinyarwanda", "sa": "S\xE2nscrito", "si": "Cingal\xEAs", "sr": "S\xE9rvio", "sr-ba": "S\xE9rvia - B\xF3snia e Herzegovina", "sr-me": "S\xE9rvio - Montenegro", "sr-rs": "S\xE9rvio - S\xE9rvia", "sr-cs": "S\xE9rvio - S\xE9rvia e Montenegro (antigo)", "sk": "Eslovaco", "sk-sk": "Eslovaco - Eslov\xE1quia", "sl": "Esloveno", "sl-si": "Esloveno - Eslov\xEAnia", "es": "Espanhol", "es-ar": "Espanhol - Argentina", "es-bo": "Espanhol - Bol\xEDvia", "es-cl": "Espanhol - Chile", "es-co": "Espanhol - Col\xF4mbia", "es-cr": "Espanhol - Costa Rica", "es-cu": "Espanhol - Cuba", "es-do": "Espanhol - Rep\xFAblica Dominicana", "es-ec": "Espanhol - Equador", "es-sv": "Espanhol - El Salvador", "es-gt": "Espanhol - Guatemala", "es-hn": "Espanhol - Honduras", "es-mx": "Espanhol - M\xE9xico", "es-ni": "Espanhol - Nicar\xE1gua", "es-pa": "Espanhol - Panam\xE1", "es-py": "Espanhol - Paraguai", "es-pe": "Espanhol - Peru", "es-pr": "Espanhol - Porto Rico", "es-es": "Espanhol - Espanha", "es-us": "Espanhol - Estados Unidos", "es-uy": "Espanhol - Uruguai", "es-ve": "Espanhol - Venezuela", "sw": "Sua\xEDli", "sv": "Sueco", "sv-fi": "Sueco - Finl\xE2ndia", "sv-se": "Sueco - Su\xE9cia", "sy": "Sir\xEDaco", "ta": "T\xE2mil", "tt": "T\xE1rtaro", "te": "Telugu", "th": "Tailand\xEAs", "th-th": "Tailand\xEAs - Tail\xE2ndia", "tl": "Tagalog", "tr": "Turco", "tr-tr": "Turco - Turquia", "uk": "Ucraniano", "uk-ua": "Ucraniano - Ucr\xE2nia", "ur": "Urdu", "uz": "Uzbeque", "vi": "Vietnamita", "vi-vn": "Vietnamita - Vietn\xE3", "yi": "I\xEDdiche", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "pt-br": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m", "days": "{{ days }} dias", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ramal {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pt-br": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pt-br', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "pt-br": { "videoPlayer": { "htmlTitle": "V\xEDdeo do HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | V\xEDdeo do HubSpot", "controls": { "audioPlayer": "Reprodutor de \xE1udio", "videoPlayer": "Reprodutor de v\xEDdeo", "play": "Reproduzir", "playVideo": "Reproduzir o v\xEDdeo", "pause": "Pausar", "replay": "Repetir", "currentTime": "Hor\xE1rio atual", "duration": "Dura\xE7\xE3o", "remainingTime": "Tempo restante", "fullscreen": "Tela cheia", "exitFullscreen": "Sair da tela cheia", "mute": "Mudo", "unmute": "Cancelar mudo", "volumeLevel": "N\xEDvel de volume", "captions": "Legendas", "captionsOff": "Desligado", "seekBar": "Ajustar posi\xE7\xE3o", "chapter": "Cap\xEDtulo", "elapsedTime": "Tempo decorrido: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Op\xE7\xF5es de reprodu\xE7\xE3o", "playbackRate": "Velocidade de reprodu\xE7\xE3o:", "quality": "Qualidade:", "normal": "Normal", "auto": "(Autom\xE1tico)" }, "formModal": { "defaultThankYouMessage": "Obrigado por sua resposta!", "inlineMessageButton": "Assistir ao v\xEDdeo" }, "ctaModal": { "imgAlt": "CTA em v\xEDdeo" }, "errors": { "generic": { "heading": "N\xE3o foi poss\xEDvel carregar o v\xEDdeo" }, "UNAUTHORIZED": { "heading": "V\xEDdeo n\xE3o ativado" }, "VIDEO_NOT_FOUND": { "heading": "V\xEDdeo n\xE3o encontrado" }, "INVALID_URL": { "heading": "V\xEDdeo n\xE3o encontrado" }, "UNSUPPORTED_EMBED": { "heading": "V\xEDdeo n\xE3o dispon\xEDvel", "extra": "O v\xEDdeo n\xE3o pode ser exibido externamente." }, "refreshLink": "Tentar novamente" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "pt-br": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:pt-br', {version: 'static-1.29208'}); }
})();


